/**
 * Dados mock para a tela de módulos / marketplace (até existir API).
 * Cada item pode ser “atrelado” à conta via Vuex (ids em marketplaceAttachedTemplateIds).
 */

export const MARKETPLACE_CATEGORIES = [
    { id: 'all', label: 'Todos' },
    { id: 'academic', label: 'Pedagógico' },
    { id: 'comms', label: 'Comunicação' },
    { id: 'admin', label: 'Administrativo' },
    { id: 'hr', label: 'Pessoas & RH' }
];

/** @typedef {{ id: string; categoryId: string; name: string; shortLabel: string; description: string; tags: string[]; popular?: boolean }} MarketplaceTemplate */

/** @type {MarketplaceTemplate[]} */
export const MARKETPLACE_TEMPLATES = [
    {
        id: 'tpl-relatorios-aee',
        categoryId: 'academic',
        name: 'Relatórios AEE assistidos',
        shortLabel: 'AEE',
        description:
            'Gera relatórios de acompanhamento com linguagem acolhedora, alinhados à BNCC e ao PEI.',
        tags: ['BNCC', 'Inclusão', 'PEI'],
        popular: true
    },
    {
        id: 'tpl-planejamento-anual',
        categoryId: 'academic',
        name: 'Planejamento anual por área',
        shortLabel: 'Planejamento',
        description:
            'Estrutura objetivos, habilidades e avaliações por bimestre com foco em matriz curricular.',
        tags: ['Matriz', 'Bimestres'],
        popular: true
    },
    {
        id: 'tpl-comunicados-familia',
        categoryId: 'comms',
        name: 'Comunicados para famílias',
        shortLabel: 'Comunicados',
        description:
            'Modelos de avisos, lembretes e circular com tom institucional claro e caloroso.',
        tags: ['WhatsApp', 'E-mail'],
        popular: true
    },
    {
        id: 'tpl-reuniao-pais',
        categoryId: 'comms',
        name: 'Pautas de reunião de pais',
        shortLabel: 'Reuniões',
        description: 'Roteiros, convites e atas com pontos de decisão e follow-up.',
        tags: ['Reunião', 'Atas']
    },
    {
        id: 'tpl-gestao-documentos',
        categoryId: 'admin',
        name: 'Gestão de documentos escolares',
        shortLabel: 'Documentos',
        description:
            'Checklist de conformidade, versionamento sugerido e textos para portarias internas.',
        tags: ['LGPD', 'Arquivo']
    },
    {
        id: 'tpl-calendario-eventos',
        categoryId: 'admin',
        name: 'Calendário de eventos escolares',
        shortLabel: 'Eventos',
        description: 'Sugestões de datas, feriados locais e comunicação antecipada ao corpo docente.',
        tags: ['Calendário', 'Feriados']
    },
    {
        id: 'tpl-onboarding-docentes',
        categoryId: 'hr',
        name: 'Onboarding de docentes',
        shortLabel: 'Onboarding',
        description: 'Trilha de boas-vindas, documentação inicial e FAQ para novos professores.',
        tags: ['RH', 'Integração']
    },
    {
        id: 'tpl-feedback-avaliacao',
        categoryId: 'hr',
        name: 'Feedback de avaliação de desempenho',
        shortLabel: 'Feedback',
        description: 'Frases construtivas e planos de melhoria contínua sem tom punitivo.',
        tags: ['Avaliação', 'PDI']
    }
];

export function templatesByCategory(categoryId) {
    if (!categoryId || categoryId === 'all') return MARKETPLACE_TEMPLATES;
    return MARKETPLACE_TEMPLATES.filter(t => t.categoryId === categoryId);
}
